import { useEffect } from 'react';

const JAPANESE_FONTS_URL =
  'https://fonts.googleapis.com/css2?family=Zen+Old+Mincho:wght@400;900&family=IBM+Plex+Sans+JP:wght@400;600;700&display=swap';
const JAPANESE_FONTS_LINK_ID = 'japanese-fonts-stylesheet';

/**
 * Hook to lazily load Japanese fonts when the user switches to Japanese locale.
 * This is used for client-side language switching - server-rendered Japanese pages
 * already have the fonts loaded via the Layout component.
 *
 * @param locale - The current locale code (e.g., 'en', 'ja')
 */
export function useJapaneseFonts(locale: string) {
  useEffect(() => {
    if (locale !== 'ja') {
      return;
    }

    // Check if fonts are already loaded (either via SSR or previous client load)
    if (document.getElementById(JAPANESE_FONTS_LINK_ID)) {
      return;
    }

    // Check if fonts were already loaded via SSR (no ID, but same href)
    const existingLink = document.querySelector(`link[href="${JAPANESE_FONTS_URL}"]`);
    if (existingLink) {
      return;
    }

    // Dynamically load Japanese fonts
    const link = document.createElement('link');
    link.id = JAPANESE_FONTS_LINK_ID;
    link.rel = 'stylesheet';
    link.href = JAPANESE_FONTS_URL;
    document.head.appendChild(link);
  }, [locale]);
}
